import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'ml-yes-no-icon',
  templateUrl: './yes-no-icon.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FaIconComponent],
})
export class YesNoIconComponent {
  readonly flag = input.required<boolean>();
  readonly yes = input('check');
  readonly no = input('times');
}
